<template>
  <div style="color:#fff" class="rightBar">
    <v-drawer :direction="'right'" :width="'26%'">
      <div class="animated fadeInRightBig" style="height:100%;width:100%;">
        <div class="panel margin--bottom">
          <bar-card :bg="'border10'">
            <v-title :title="graphic.name">
              {{ graphic.name | ellipsis }}
            </v-title>
            <div class="content">
              <div class="closeDraw">
                <el-button icon="el-icon-close" @click="closeClick"></el-button>
              </div>
              <div class="tabPanel">
                <basic />
                <vTab ref="tab" style="height: 50%" />
              </div>
            </div>
          </bar-card>
        </div>
      </div>
    </v-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import basic from "./enterpriseDrawer/basic";
import vTab from "./enterpriseDrawer/tab";
export default {
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 9) {
        return value.slice(0, 9) + "...";
      }
      return value;
    }
  },
  computed: {
    ...mapGetters(["graphic"])
  },
  components: { basic, vTab },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    closeClick() {
      // this.$store.dispatch("drawer/setRightComponent", "rightDrawer");
      this.$store.dispatch("drawer/setRightComponent", "ssztDrawer0");
      this.$store.dispatch("drawer/setGraphic", null);
    }
  },
  destroyed() {
    this.$store.dispatch("drawer/setGraphic", null);
  }
};
</script>

<style lang="stylus" scoped>
.panel
  height calc(100% - 8px)
  width 100%
  font-size 0.06rem
.content
  height calc(100% - 43px)
  width calc(100% - 20px)
  padding 0 10px
  position relative
.closeDraw
  position absolute
  right 10px
  top -30px
  .el-button
    background transparent
    color #fff
    font-size 25px
    padding 0
    border 0
    position relative
.warn
  padding 0
  background transparent
  border 0
  color #fff
  font-size 0.18rem
  &:hover
    background transparent
    color #fff
p
  text-indent 28px
  line-height 20px
  font-size 13px
  letter-spacing 2px
.tabPanel
  height calc(100% - 0px)
  width calc(100% - 0px)
  &::-webkit-scrollbar
    width 4px
    background-color #00162D
  /* 定义滚动条轨道 内阴影+圆角 */
  &::-webkit-scrollbar-track
    -webkit-box-shadow inset 0 0 6px transparent
    background-color transparent
  /* 定义滑块 内阴影+圆角 */
  &::-webkit-scrollbar-thumb
    border-radius 10px
    -webkit-box-shadow inset 0 0 6px transparent
    background-color #0ff
  /* 定义最上方和最下方的按钮 */
  &::-webkit-scrollbar-button
    height 0
@media (min-width 1700px)
  .el-timeline
    height 80vh
@media (min-height 1400px)
  .content
    height calc(100% - 79px)
  .rightBar
    >>>.side
      width 24% !important
  .closeDraw
    top -60px
    right 20px
    .el-button
      font-size 40px
@media (max-width 1280px)
  .content
    height calc(100% - 25px)
  .closeDraw
    top -20px
    .el-button
      font-size 15px
</style>
